import { render, staticRenderFns } from "./SupportCategoryEdit.vue?vue&type=template&id=4c07e81c&"
import script from "./SupportCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./SupportCategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupportCategoryEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports